import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CheckIdTagAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-check-id-tag-slot',
    templateUrl: './check-id-tag-slot.component.html',
    styleUrl: './check-id-tag-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckIdTagSlotComponent implements SheetSlotComponentBase {

	@Input() action!: CheckIdTagAction;
	value = null;

	constructor() {
	}
}